// @ts-strict-ignore
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { InitialProps } from "@shared/types/initialProps";

const InitialPropsContext = createContext<InitialProps>(null);

const useInitialProps = (): InitialProps => {
  const initialProps: InitialProps = useContext(InitialPropsContext);

  return initialProps;
};

interface Props {
  children: ReactNode;
  initialProps: InitialProps;
}

/**
 * Used to expose InitialProps from the server into the client once rendered
 *
 * see: app/javascript/packs/openCatalog.tsx and app/javascript/server/routers/catalog/catalog.tsx for usage
 */
const InitialPropsProvider = ({ children, initialProps }: Props) => {
  return <InitialPropsContext value={initialProps}>{children}</InitialPropsContext>;
};

export { InitialPropsContext, InitialPropsProvider, useInitialProps };
